const STORAGE_KEY = 'cheerfy_dismissed_features';

// FEATURES: add a new entry for each future feature.
// expiresAt: the date after which the tag should no longer be shown, in YYYY-MM-DD format.
const FEATURES: NewFeatureTag.Feature[] = [
    { id: 'messages_download_csv', expiresAt: '2026-01-09' },
];

export class NewFeatureTag {
    private static _instance: NewFeatureTag | undefined = undefined;

    public static get instance(): NewFeatureTag {
        if (NewFeatureTag._instance === undefined) {
            NewFeatureTag._instance = new NewFeatureTag();
        }
        return NewFeatureTag._instance;
    }

    private _getDismissed(): Record<string, boolean> {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
        } catch {
            return {};
        }
    }

    public isVisible(featureId: string): boolean {
        const feature = FEATURES.find((f) => f.id === featureId);
        if (!feature) return false;
        if (new Date() >= new Date(feature.expiresAt)) return false;
        return !this._getDismissed()[featureId];
    }

    public dismiss(featureId: string): void {
        const dismissed = this._getDismissed();
        dismissed[featureId] = true;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(dismissed));
    }

    public initAll(): void {
        document.querySelectorAll<HTMLElement>('.new-feature-tag[data-feature-id]').forEach((el) => {
            if (!this.isVisible(el.dataset.featureId!)) {
                el.style.display = 'none';
            }
        });
    }
}

export namespace NewFeatureTag {
    export type Feature = {
        id: string;
        expiresAt: string;
    };

    export type FeatureId = typeof FEATURES[number]['id'];
}
